const translations = {
    "Customer_details": "تفاصيل العميل",
    "Advance_Receipt": "إيصال دفعة مقدمة",
    Customer_Name: "اسم العميل",
    Customer_Number:"رقم العميل",
    Name:"الاسم",
    Lens:"عدسة",
    Contact_Lens:"عدسة لاصقة",
    Mobile_No: "رقم الجوال",
    "Alternate_Mobile": "رقم جوال بديل",
    "Order_Number": "رقم الطلب",
    "Date_of_Order": "تاريخ الطلب",
    "Delivery_Date": "تاريخ التسليم",
    "Delivery_Address": "عنوان التسليم",
    "Product_Details": "تفاصيل المنتج",
    "Price": "السعر",
    "Discount": "خصم",
    "Total_Discount": "إجمالي الخصم",
    "Total_Received": "إجمالي المبلغ المستلم",
    "Balance_Receivable": "الرصيد المستحق",
    "Receipt_Details": "إيصال التفاصيل",
    "Cash": "نقدًا",
    "Card": "بطاقة",
    "Online": "دفع عبر الإنترنت",
    "Balance_Used": "الرصيد المستخدم",
    "Bank": "تحويل بنكي",
    "Gross_Total": "الإجمالي الكلي",
    "Total": "المجموع",
    "Net_Total_Amount": "المبلغ الإجمالي الصافي",
    "Net Amount": "المبلغ الصافي",
    "Terms_and_Conditions": "الشروط والأحكام",
    "Company_Name": "اسم الشركة",
    "Thanks_and_Visit_again": "شكرًا ونرجو زيارتكم مرة أخرى",
    "Coupon": "قسيمة خصم",
    "Round_Off": "التقريب",
    "YOU_SAVE": "لقد وفرت",

    "Lens_Prescription": "وصفة العدسات",
    "Contact_Lens_Prescription": "وصفة العدسات اللاصقة",
    "Patient_Name": "اسم المريض",
    "Mobile": "رقم الجوال",
    "Right_Eye": "العين اليمنى",
    "Left_Eye": "العين اليسرى",
    "SPH": "قوة العدسة",
    "CYL": "الاسطوانة",
    "AXIS": "المحور",
    "PD": "المسافة بين الحدقتين",
    "Distance_Vision": "الرؤية البعيدة",
    "Near_Vision": "الرؤية القريبة",
    "Addition": "الإضافة",
    "Invoice": "فاتورة.",
    "Invoice_Number": "رقم الفاتورة",
    "Invoice_Date": "تاريخ الفاتورة",
    "Invoice_Time": "وقت الفاتورة",
    "Code": "رمز",
    "VAT": "ض.ق.م",
    "Sale_Value": "قيمة البيع",
    "Total_VAT_Amount": "إجمالي ض.ق.م",
    "VAT_DETAILS": "تفاصيل ض.ق.م",
    // "Order_Number": "رقم الطلب",
    "ORDER_FORM": "نموذج الطلب",
    "Credit_Note": "إشعار دَين",
    "Credit_Note_No.": "رقم إشعار الدَين",
    "Credit_Note_Date": "تاريخ إشعار الدَين",
    "Payment_Voucher": "قسيمة الدفع",
    "Voucher_No.": "رقم القسيمة",
    "Payment_Date": "تاريخ الدفع",
    "Mode_Of_Payment": "طريقة الدفع",
    "Transaction_Number": "رقم المعاملة",
    "Amount": "المبلغ",
    "Received_&_Acknowledged_By":"تم الاستلام والإقرار بواسطة",
    "Warranty_Details": "تفاصيل الضمان",
    "Claim_ID": "معرف المطالبة",
    "Claim_Resolution_Document": "وثيقة حل المطالبة",
    "Claim_Resolution_ID": "معرف حل المطالبة",
    "Date":"تاريخ",
    Store:"متجر",
    "Invoice_No.":"رقم الفاتورة",
};


export default translations